const IconPin = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M0 0V12.8105C5.65909 12.8105 5.99999 20 5.99999 20C5.99999 20 6.34091 12.8105 12 12.8105V0H0ZM9.36364 6.40856C9.36364 8.39179 7.85743 9.99999 5.99999 9.99999C4.14256 9.99999 2.63636 8.39179 2.63636 6.40856C2.63636 4.42532 4.14256 2.81711 5.99999 2.81711C7.85743 2.81711 9.36364 4.42532 9.36364 6.40856Z"
            fill={color}
        />
    </svg>
);

export default IconPin;
